module.exports = __webpack_public_path__ + "img/flot4.3cf6e4e4.svg";